import React, { useEffect, useState } from 'react';
import { Card, Col, Dropdown, Form, Row } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import Avatar from 'components/base/Avatar';
// import avatar from 'assets/img/team/72x72/58.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
// import Badge from 'components/base/Badge';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from 'providers/AppProvider';
import { ContactPerson, JobClient } from 'data/users';
import HumanReadableTime from 'components/utils/HumanReadableTime';
import { useQuery } from 'react-query';
import { GET_COMPANY_REPS } from 'services/api/customer';

const CompanyProfileCard = ({
  className,
  company
}: {
  className?: string;
  company: JobClient;
}) => {
  const {
    config: { isRTL }
  } = useAppContext();
  const [allReps, setAllReps] = useState<ContactPerson[]>([]);
  const companyId = (company as any).id || company._id;
  const {
    isLoading,
    data: rep,
    isError,
    isSuccess
  } = useQuery(['GET_COMPANY_REPS', companyId], () =>
    companyId ? GET_COMPANY_REPS(companyId) : Promise.reject('No id provided')
  );

  useEffect(() => {
    if (isSuccess) {
      setAllReps(rep?.data);
    }
  }, [isSuccess, rep, setAllReps, allReps]);

  return (
    <Card className={className}>
      <Card.Body>
        <Row className="align-items-center g-3">
          <Col sm="auto" className="flex-1">
            <h3 className="fw-bolder mb-2 line-clamp-1">
              {company.organizationName}
            </h3>
            <div className="d-flex align-items-center mb-4">
              <FeatherIcon
                icon="bookmark"
                className="d-inline-block lh-sm me-1"
                width={16}
                height={16}
              />
              <h5 className="mb-0 me-4">Country: {company?.country}</h5>
              <h5 className="fw-semi-bold">
                <FeatherIcon
                  icon="map"
                  className="d-inline-block lh-sm me-1"
                  width={16}
                  height={16}
                />
                <span className="d-inline-block lh-sm">
                  State: {company?.state}
                </span>
              </h5>
            </div>
            <div className="d-md-flex d-xl-block align-items-center justify-content-between mb-5">
              <div className="d-flex align-items-center mb-3 mb-md-0 mb-xl-3">
                <Avatar
                  size="xl"
                  src={company?.companyLogoUrl}
                  className="me-3"
                />
                <div>
                  <h5>
                    {company?.customerRepresentative != null
                      ? `${company?.customerRepresentative?.firstName} ${company?.customerRepresentative?.lastName}`
                      : 'No Company Representative'}
                  </h5>
                  <Dropdown align={isRTL ? 'end' : 'start'}>
                    <Dropdown.Toggle
                      variant="link"
                      className="text-800 text-decoration-none dropdown-caret-none p-0 fs-8 fw-normal"
                    >
                      Company Representative
                      <FontAwesomeIcon
                        icon={faCaretDown}
                        className="text-800 fs-9 ms-2"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      className="shadow-sm"
                      style={{ minWidth: '20rem' }}
                    >
                      <Card className="position-relative border-0">
                        <Card.Body className="p-0">
                          <div className="mx-3">
                            <h4 className="mb-3 fw-bold">
                              Switch Representative
                            </h4>
                            <Form.Select className="mb-3">
                              <option value="">Select</option>
                              {isError && (
                                <>Error getting all Company's Representative</>
                              )}
                              {isLoading && <>...</>}
                              {isSuccess &&
                                allReps.map(representative => (
                                  <option
                                    value={
                                      (representative as any).id ||
                                      representative._id
                                    }
                                    key={
                                      (representative as any).id ||
                                      representative._id
                                    }
                                  >
                                    {representative.firstName}{' '}
                                    {representative.lastName}
                                  </option>
                                ))}
                            </Form.Select>
                            <div className="text-end">
                              <Button variant="link" className="text-danger">
                                Cancel
                              </Button>
                              <Button
                                size="sm"
                                variant="primary"
                                className="px-5"
                              >
                                Save
                              </Button>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
              {/* <div>
                <Badge variant="phoenix" bg="success" className="me-2">
                  Success
                </Badge>
                <Badge variant="phoenix" bg="danger" className="me-2">
                  Lost
                </Badge>
                <Badge variant="phoenix" bg="secondary">
                  Close
                </Badge>
              </div> */}
            </div>
            {/* <ProgressBar variant="primary-200" now={40} className="mb-2" /> */}
            <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0">New</p>
              <div>
                <FeatherIcon
                  icon="clock"
                  className="lh-sm me-1"
                  width={16}
                  height={16}
                />
                <span className="d-inline-block lh-sm">
                  <HumanReadableTime
                    date={new Date(company.createdAt as Date)}
                  />
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CompanyProfileCard;
